import { AutogenLayoutEdiCustomerSlideout } from "./autogen/AutogenLayoutEdiCustomerSlideout";

export class EdiCustomerSlideout extends AutogenLayoutEdiCustomerSlideout {
    
}